export const apiSlugToDimensionName = {
  iol: 'IO Line',
  ds: 'Datasource',
  aud: 'Audience',
  inv_type: 'Inventory Type',
  plcmnt: 'Placement',
  typ: 'Device Type',
  agency: 'Agency',
  brand: 'Brand',
  ad: 'Ad',
  site: 'Site',
  channel: 'Channel',
  publisher: 'Publisher',
  creative: 'Creative',
  ad_frequency: 'Ad Frequency',
  visit_frequency: 'Visitor Frequency',
} as const;
